import { useEffect } from "react";

export default function SEO({ title, description, image }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:image", image, true);
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [title, description, image]);
  return null;
}
